// extracted by mini-css-extract-plugin
export var trans = "styles-module--trans--3cUPD";
export var trans_wrap = "styles-module--trans_wrap--j3vcy";
export var trans_bg = "styles-module--trans_bg--35hOb";
export var trans_card = "styles-module--trans_card--3BT2B";